var render, staticRenderFns
import script from "./v-calendar.vue?vue&type=script&lang=js&"
export * from "./v-calendar.vue?vue&type=script&lang=js&"
import style0 from "./v-calendar.vue?vue&type=style&index=0&id=68a16e91&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a16e91",
  null
  
)

export default component.exports